import { useState } from "react";
import color from "context/MaterialUITheme/color";
import Typography from "@mui/material/Typography";
import DemographicDataDialog from "./DemographicDataDialog";
import CTrackerTimelineItem, {
  trackerStatusColor,
} from "components/CTimelineItem";
import useTracker from "components/CTracker/useTrackerContext";

const DemographicDataVerification: React.FC = () => {
  const { loan, type } = useTracker();
  const isBorrower = type === "borrower";
  const step = isBorrower ? loan?.borrowerSteps : loan?.coborrowerSteps;
  const demographicDataVerification = step?.demographicsVerification;
  const incomeVerification = step?.incomeVerification;
  const status = step?.demographicsVerification?.status ?? "pending";
  const message = step?.demographicsVerification?.message ?? "";
  const [demographicsDialogOpen, setDemographicsDialogOpen] = useState(false);

  return (
    <CTrackerTimelineItem
      status={status}
      title="Demographics (optional)"
      tooltip="This is an optional field, but we do request that you fill out this information so that we can accurately report to HMDA."
      {...(demographicDataVerification?.status !== "success" &&
        incomeVerification?.status === "success" && {
          action: {
            message: "Add Demographics Data",
            onClick: () => setDemographicsDialogOpen(true),
          },
        })}
    >
      <Typography
        variant="h6"
        color={color[trackerStatusColor[status] as keyof typeof color]}
      >
        {status === "analyzing" && "Analyzing"}
        {status === "failed" && message}
        {status === "success" && message}
      </Typography>
      <DemographicDataDialog
        open={demographicsDialogOpen}
        onClose={() => setDemographicsDialogOpen(false)}
      />
    </CTrackerTimelineItem>
  );
};

export default DemographicDataVerification;
